import React from "react";
import { connect } from "react-redux";
import { DataGrid, TextBox } from "devextreme-react";
import { Selection, Column } from "devextreme-react/ui/data-grid";
import UserInfoColumn from "../../../../../Shared/UserInfoColumn";
// import { setSearchUserDetailText } from "../actions";

class ListaUsuariosDetalle extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      searchTextDetailUser: null,
    };
    this.tableRef = React.createRef();
    this.timeout = 0;
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.isOpenDetails !== this.props.isOpenDetails && this.props.isOpenDetails === false) {
      this.tableRef.searchByText(null);
      this.setState({
        searchTextDetailUser: null,
      });
    }
  }

  handleSelection = (event) => {
    if (this.props.onSelect) this.props.onSelect(event);
  }

  handleSearch = (e) => {
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.tableRef.searchByText(e.value);
    }, 100);
    this.setState({
      searchTextDetailUser: e.value,
    });
  }
  renderGridInterno() {
    return (
      <DataGrid
        dataSource={this.props.usuarios}
        showBorders={false}
        ref={(ref) => { if (ref !== null) this.tableRef = ref.instance; }}
        onSelectionChanged={this.handleSelection}
        showColumnLines={false}
        selectedRowKeys={this.props.selected}
        showRowLines={false}
        height={this.props.height || undefined}
        noDataText="Sin resultados"
        className="custom-table"
        rowAlternationEnabled
        hoverStateEnabled
      >

        <Selection
          showCheckBoxesMode="always"
          mode="multiple"
          allowSelectAll={false}
        />

        <Column
          allowSearch
          caption="Trabajador"
          dataField="name"
          calculateCellValue={(rowData) => `${rowData.EmployeeName} ${rowData.EmployeeRut}`}
          cellComponent={(row) => (
            <UserInfoColumn
              nombre={row.data.EmployeeName}
              rut={row.data.NotificationGroupCode ? row.data.EmployeeRut : row.data.Rut}
            />
          )}
        />
        <Column
          allowSearch={false}
          caption="Rol empresa"
          cssClass="columna-rol"
          dataField="Roles"
          calculateCellValue={(rowData) => {
            if (rowData.NotificationGroupCode) {
              return rowData.Roles ? rowData.Roles.join(", ") : "";
            }
            return rowData.Roles ? rowData.Roles.map((e) => e.Name ? e.Name : e.Description).join(", ") : "";
          }}
        />
        <Column
          visible={!this.props.hideDate}
          caption="Fecha de asignación"
          dataField="asignDate"
          dataType="date"
          calculateDisplayValue={(props) => props.date || "S/D"}
        />
      </DataGrid>
    );
  }
  renderGridExterno() {
    return (
      <DataGrid
        dataSource={this.props.usuarios}
        showBorders={false}
        ref={(ref) => { if (ref !== null) this.tableRef = ref.instance; }}
        onSelectionChanged={this.handleSelection}
        showColumnLines={false}
        selectedRowKeys={this.props.selected}
        showRowLines={false}
        height={this.props.height || undefined}
        noDataText="Sin resultados"
        className="custom-table"
        rowAlternationEnabled
        hoverStateEnabled
      >
        <Selection
          showCheckBoxesMode="always"
          mode={this.props.availableListUser !== true ? "multiple" : "single"}
          allowSelectAll={false}
        />
        <Column
          allowSearch
          caption="Trabajador"
          dataField="Name"
          calculateCellValue={(rowData) => `${rowData.Name} ${rowData.LastName}`}

        />
        <Column
          allowSearch
          caption="Email"
          dataField="Email"
        />
        <Column
          allowSearch
          caption="Teléfono"
          dataField="Cellphone"
        />
      </DataGrid>
    );
  }
  render() {
    return (
      <React.Fragment>
        <div style={{ display: "flex", marginBottom: 10, marginTop: 10 }}>
          <TextBox

            placeholder="Buscar trabajador"
            mode="search"
            style={{ flexGrow: 1 }}
            onValueChanged={this.handleSearch}
            value={this.state.searchTextDetailUser}
            valueChangeEvent="input"
            activeStateEnabled={false}
          />
          {this.props.actions}
        </div>
        {this.props.typeUserRelationFilter === "INT" && this.renderGridInterno()}
        {this.props.typeUserRelationFilter === "EXT" && this.renderGridExterno()}


      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  usuarios: state.notificacionesEmpresa.selectedNotification ? state.notificacionesEmpresa.selectedNotification.Subscriptors : [],
  typeUserRelationFilter: state.notificacionesEmpresa.typeUserRelationFilter,
  isOpenDetails: state.notificacionesEmpresa.isOpenDetails,


});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(ListaUsuariosDetalle);

